import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../../App";
import { FiArrowUpRight } from "react-icons/fi";
import HeaderTitle from "../HederTitle/HeaderTitle";

const PLACES = ["Place 1","Place 2","Place 3","Place 4","Place 5","Place 6","Place 7"];

const SPANS = [
  "lg:col-span-2 lg:row-span-2",
  "lg:col-span-1 lg:row-span-1",
  "lg:col-span-1 lg:row-span-1",
  "lg:col-span-2 lg:row-span-1",
  "lg:col-span-1 lg:row-span-1",
  "lg:col-span-1 lg:row-span-1",
  "lg:col-span-2 lg:row-span-1",
];

const Variety = () => {
  const [varieties, setVarieties] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { fetchVarieties(); }, []);

  const fetchVarieties = async () => {
    try {
      const res = await axios.get(`${backend_url}/api/variety`);
      setVarieties(res.data);
    } catch (e) { console.error(e); }
  };

  const placeMap = {};
  varieties.forEach(v => { placeMap[v.placeTo] = v; });

  return (
    <section
      className="relative overflow-hidden py-16 px-4 sm:px-8 lg:px-16"
      style={{ background: "linear-gradient(135deg,#fff8f2 0%,#fdf5ff 55%,#fff8f2 100%)" }}
    >
      {/* Ambient glows */}
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full blur-3xl opacity-25 pointer-events-none"
        style={{ background: "radial-gradient(circle,#f9a8d4,transparent)" }} />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle,var(--brand-primary-300),transparent)" }} />

      {/* Ghost text */}
      <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-black whitespace-nowrap pointer-events-none select-none"
        style={{
          fontSize: "clamp(60px,14vw,180px)",
          color: "transparent",
          WebkitTextStroke: "1px rgba(0,0,0,0.04)",
          letterSpacing: "-0.04em",
        }}>
        COLLECTIONS
      </p>

      <div className="relative max-w-7xl mx-auto">

        {/* Header — same style as Retro Collections / Top Sellers / Featured In */}
        <div className="mb-8">
          <HeaderTitle Header="Variety of Collections" />
        </div>

        {/* Mosaic grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[190px] lg:auto-rows-[205px] gap-3">
          {PLACES.map((place, index) => {
            const item = placeMap[place];
            const isHero = index === 0;

            return (
              <div
                key={index}
                onClick={() => item?.routeTo && navigate(`/collections/${item.routeTo}`)}
                className={`group relative overflow-hidden rounded-2xl transition-all duration-500
                            ${!item ? "hidden lg:hidden" : ""}
                            ${item?.routeTo ? "cursor-pointer" : "cursor-default"}
                            ${SPANS[index]}`}
                style={{ boxShadow: "0 2px 16px rgba(0,0,0,0.10)" }}
                onMouseEnter={e => {
                  e.currentTarget.style.boxShadow =
                    "0 0 0 2px rgba(168,85,247,0.5), 0 16px 48px rgba(168,85,247,0.22), 0 4px 16px rgba(0,0,0,0.10)";
                  e.currentTarget.style.transform = "translateY(-5px) scale(1.01)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.10)";
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                }}
              >
                {item ? (
                  <>
                    {/* Full-bleed image */}
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={item.image}
                      alt={item.collectionName}
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                    />

                    {/* Bottom fade for legible text on the photo */}
                    <div className="absolute inset-x-0 bottom-0 h-2/3 pointer-events-none"
                      style={{ background: "linear-gradient(to top,rgba(0,0,0,0.62),rgba(0,0,0,0) 65%)" }} />

                    {/* Label */}
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <p className={`font-bold leading-tight text-white line-clamp-2 drop-shadow ${isHero ? "text-base" : "text-sm"}`}>
                        {item.collectionName}
                      </p>
                      <p className="text-[11px] font-medium mt-1 text-white/80 flex items-center gap-1">
                        Explore collection
                        <FiArrowUpRight size={12} className="transition-transform duration-300 group-hover:translate-x-1" />
                      </p>
                    </div>
                  </>
                ) : null}
              </div>
            );
          })}
        </div>

        {/* Bottom rule */}
        <div className="mt-12 flex items-center gap-4">
          <div className="flex-1 h-px" style={{ background: "linear-gradient(to right,rgba(168,85,247,0.5),transparent)" }} />
          <span className="text-[var(--brand-primary-300)] text-[10px] font-bold tracking-[0.3em] uppercase">
            {varieties.length} Collections
          </span>
          <div className="flex-1 h-px" style={{ background: "linear-gradient(to left,rgba(168,85,247,0.5),transparent)" }} />
        </div>
      </div>
    </section>
  );
};

export default Variety;
